/**
 * systems/audio.ts — v4 cleanup: typed, minimal, no dead code
 */

let ctx: AudioContext | null = null;
let bedGain: GainNode | null = null;
let bedOsc: OscillatorNode | null = null;
let bedLfo: OscillatorNode | null = null;
let muted = localStorage.getItem("doorpost.mute") === "1";

function ac(): AudioContext | null {
  try {
    const AC =
      window.AudioContext ||
      (window as unknown as { webkitAudioContext: typeof AudioContext })
        .webkitAudioContext;
    if (!AC) return null;
    if (!ctx) ctx = new AC();
    return ctx;
  } catch {
    return null;
  }
}

export function isMuted(): boolean {
  return muted;
}

export function setMuted(v: boolean): void {
  muted = v;
  localStorage.setItem("doorpost.mute", v ? "1" : "0");
  if (bedGain) bedGain.gain.value = v ? 0 : 0.012;
}

export async function ensureAudio(): Promise<void> {
  const c = ac();
  if (!c) return;
  if (c.state === "suspended") await c.resume();
  if (bedOsc) return;
  bedOsc = c.createOscillator();
  bedOsc.type = "sine";
  bedOsc.frequency.value = 72;
  bedLfo = c.createOscillator();
  bedLfo.frequency.value = 0.05;
  const lfoGain = c.createGain();
  lfoGain.gain.value = 8;
  bedLfo.connect(lfoGain);
  lfoGain.connect(bedOsc.frequency);
  bedGain = c.createGain();
  bedGain.gain.value = muted ? 0 : 0.012;
  bedOsc.connect(bedGain);
  bedGain.connect(c.destination);
  bedOsc.start();
  bedLfo.start();
}

export function syncAudioVisibility(): void {
  if (!ctx) return;
  if (document.hidden) void ctx.suspend();
  else if (bedOsc) void ctx.resume();
}

export function destroyAudio(): void {
  try {
    bedOsc?.stop();
    bedLfo?.stop();
  } catch {
    /* already stopped */
  }
  bedOsc?.disconnect();
  bedLfo?.disconnect();
  bedGain?.disconnect();
  bedOsc = null;
  bedLfo = null;
  bedGain = null;
  const closing = ctx;
  ctx = null;
  if (closing && closing.state !== "closed") void closing.close();
}

export function zoneStinger(seed = 440): void {
  if (muted) return;
  const c = ac();
  if (!c) return;
  void c.resume();
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = "triangle";
  o.frequency.value = seed;
  g.gain.value = 0.03;
  o.connect(g);
  g.connect(c.destination);
  o.start();
  o.frequency.exponentialRampToValueAtTime(seed * 1.5, c.currentTime + 0.15);
  g.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + 0.2);
  o.stop(c.currentTime + 0.22);
}
